import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import {apiBaseUrl} from './Config';

class ChangeUserInfoModal extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    firstname: "",
	    lastname: "",
	    email: "",
	    troop: "",
	    year: "",
	    disabled: true
	};

	this.resource = apiBaseUrl + "users/" + props.userid;

	this.handleChange = this.handleChange.bind(this);
	this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
	fetch(this.resource, {
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Accept": "application/json"
	    }
	})
	    .then(response => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		if (!response.ok) {
		    throw new Error("");
		}
		
		return response.json()
	    })
	    .then((result) => {
		this.setState({
		    firstname: result.firstname,
		    lastname: result.lastname,
		    email: result.email,
		    troop: result.troop,
		    year: result.year,
		});
	    })
	    .catch((error) => {
		this.props.onError();
	    })
    }

    componentDidUpdate(prevProps, prevState) {
	// Only do this when one of the fields changes
	if (this.state.firstname !== prevState.firstname ||
	    this.state.lastname !== prevState.lastname ||
	    this.state.email !== prevState.email ||
	    this.state.troop !== prevState.troop ||
	    this.state.year !== prevState.year)
	{
	    // All fields except 'year' have to be filled in to enable submit button
	    if (this.state.firstname !== "" &&
		this.state.lastname !== "" &&
		this.state.email !== "" &&
		this.state.troop !== "")
	    {
		this.setState({disabled: false});
	    } else {
		this.setState({disabled: true});
	    }
	}
    }
    
    handleChange(event) {
	this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event) {
	const data = {
	    firstname: this.state.firstname,
	    lastname: this.state.lastname,
	    email: this.state.email,
	    troop: this.state.troop,
	    year: this.state.year,
	};

	fetch(this.resource, {
	    method: "PUT",
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Content-Type": "application/json"
	    },
	    body: JSON.stringify(data)
	})
	    .then((response) => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		if (!response.ok) {
		    throw new Error("Kunde inte uppdatera");
		}
		
		return response.json();
	    })
	    .then((result) => {
		this.props.onSuccess();
	    })
	    .catch((error) => {
		this.props.onError();
	    });
	
	event.preventDefault();
    }

    render() {
	return (
	    <Modal show={this.props.show} onHide={this.props.onHide}>
		<Modal.Header closeButton>
		    <Modal.Title>&Auml;ndra uppgifter</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		    <Form>
			<Form.Group>
			    <Form.Text>
				H&auml;r kan du uppdatera dina uppgifter.
			    </Form.Text>
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>F&ouml;rnamn</Form.Label>
			    <Form.Control name="firstname" type="text" autoFocus value={this.state.firstname} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Efternamn</Form.Label>
			    <Form.Control name="lastname" type="text" value={this.state.lastname} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Email</Form.Label>
			    <Form.Control name="email" type="text" value={this.state.email} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Scouk&aring;r</Form.Label>
			    <Form.Control name="troop" type="text" value={this.state.troop} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Kurs&aring;r</Form.Label>
			    <Form.Control name="year" type="text" value={this.state.year} onChange={this.handleChange} />
			    <Form.Text>
				Under "Kurs&aring;r" anger du &aring;ret du gick kursen. Om du har g&aring;tt mer &auml;n en g&aring;ng anger du f&ouml;rsta &aring;ret som du fullf&ouml;ljde kursen.
			    </Form.Text>
			</Form.Group>
		    </Form>
		</Modal.Body>
		<Modal.Footer>
		    <Button variant="alumni" onClick={this.props.onHide}>Avbryt</Button>
		    {this.state.disabled?
		     <Button variant="alumni" onClick={this.handleSubmit} disabled>Spara</Button>
		     :
		     <Button variant="alumni" onClick={this.handleSubmit}>Spara</Button>
		    }
		</Modal.Footer>
	    </Modal>
	);
    }
}

export default ChangeUserInfoModal;
